<mat-card class="mag" style="width: max-content; box-sizing: border-box; max-width: calc(100% - 40px);">

  <!-- Show registration form if showRegistrationForm is true -->
  @if(showRegistrationForm) {
    <mat-card-header>
      <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
        <div class="left">
          <mat-card-title>New Patient Registration</mat-card-title>
          <mat-card-subtitle>Register a new patient in the system</mat-card-subtitle>
        </div>
        <div class="right gap-10 g-just-flex" style="justify-content: flex-end;">
          <button mat-icon-button (click)="closeRegistrationForm()" matTooltip="Close Registration">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content class="my-12">
      <mat-divider></mat-divider>
      <div class="registration-form-container">
        <app-patient-registration
          [isInlineMode]="true"
          (registrationComplete)="closeRegistrationForm()">
        </app-patient-registration>
      </div>
    </mat-card-content>
  }

  <!-- Show patient registration list if showRegistrationForm is false -->
  @else {
    <mat-card-header>
      <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
        <div class="left">
          <mat-card-title>{{pageTitle}}</mat-card-title>
          <mat-card-subtitle>{{pageSubtitle}}</mat-card-subtitle>
        </div>
        <div class="right gap-10 g-just-flex" style="justify-content: flex-end; flex-wrap: wrap;">
          <a *ngIf="canAddPatientRegistration()"
             mat-flat-button
             extended
             class="secondary-button small-button"
             (click)="openPatientImport()">
            <mat-icon>file_upload</mat-icon> Import
          </a>
          <a mat-flat-button extended class="secondary-button small-button">
            <mat-icon>file_download</mat-icon> Export
          </a>
          <a *ngIf="canAddPatientRegistration()"
             mat-flat-button
             extended
             class="primary-button small-button"
             (click)="onRegisterButtonClick()">
            <mat-icon>person_add</mat-icon> New Registration
          </a>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content class="my-12">
      <mat-divider></mat-divider>
      <app-table-header [patientsTableFilterArray]="tableFilter"
          [patientsFiltersFormControlObject]="tableFilterFormControlObject"
          [searchableFields]="searchableFields"
          [selectedSearchField]="selectedSearchField"
          [searchBoxTitle]="'Search Registration'"
          [hasData]="((tableDataLevel2 | async)?.length ?? 0) > 0"
          [showWhenSearching]="true"
          (filterChanged)="onFilterChanged($event)"
          (searchCriteriaChanged)="onSearchCriteriaChanged($event)">
      </app-table-header>

      @if(tableDataLevel2 | async; as tableData){
        @if(tableData.length === 0){
          <app-empty-state [title]="'No ' + (pageTitle || 'Patient Registrations')"
              icon="hourglass_empty"
              [subtitle]="pageTitle === 'Pending Patient Registrations' ? 'All patient registrations have been processed. Newly registered inactive patients will appear here until approved.' : 'There are currently no records in this category.'">
          </app-empty-state>
        }@else {
          <table mat-table matSort [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table my-30">

            <!-- Number Column -->
            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="number" sortActionDescription="Sort by Number">
              </th>
              <td mat-cell *matCellDef="let element; let i = index">{{i + 1 + (paginator.pageIndex * paginator.pageSize)}}</td>
            </ng-container>

            <!-- Action Column -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="action">
                Action
              </th>
              <td mat-cell *matCellDef="let element; let i = index;">
                <mat-icon [mat-menu-trigger-for]="mem">more_vert</mat-icon>
                <mat-menu #mem="matMenu" class="action-menu compact-menu">
              
                 <button mat-menu-item (click)="viewDetails(element)">
                    <mat-icon>visibility</mat-icon>
                    <span>View Details</span>
                  </button>

                  <!-- In 'approved' view, show Edit and Archive -->
                  <button *ngIf="currentSegment === 'approved' && canEditPatient()" mat-menu-item (click)="editPatient(element)">
                    <mat-icon>edit</mat-icon>
                    <span>Edit View</span>
                  </button>
                  <button *ngIf="currentSegment === 'approved'" mat-menu-item (click)="archivePatient(element)">
                    <mat-icon>archive</mat-icon>
                    <span>Archive</span>
                  </button>

                  <!-- In 'archived' view, show Reactivate and Delete -->
                  <button *ngIf="currentSegment === 'archived'" mat-menu-item (click)="reactivatePatient(element)">
                    <mat-icon>restore</mat-icon>
                    <span>Reactivate</span>
                  </button>
                  <button *ngIf="currentSegment === 'archived'" mat-menu-item (click)="checkAndDeletePatient(element)">
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button>

                  <!-- In 'deceased' view, only show View Details -->
                  <button *ngIf="currentSegment === 'deceased'" mat-menu-item (click)="viewDetails(element)">
                    <mat-icon>visibility</mat-icon>
                    <span>View Details</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <!-- Dynamic Columns -->
            @for(column of tableColumns; let j = $index; track $index){
              @if(column !== 'action'){
                <ng-container matColumnDef="{{column}}">
                  <th mat-header-cell *matHeaderCellDef>
                    {{column | titlecase}}
                  </th>
                 <td mat-cell *matCellDef="let element; let i = index;">
  @if(column == 'patient id'){
    @if(getPatientHospitalId(element)){
      <span>{{getPatientHospitalId(element)}}</span>
    }@else {
      <span class="subtitle-text-color-2">N / A</span>
    }
  }@else if(column == "name"){
    @if(element.name && element.name.length > 0){
      {{element.name?.[0]?.family}} {{element.name?.[0]?.given?.[0]}}
    }@else if(element.fullName){
      {{element.fullName}}
    }@else if(element.firstName && element.lastName){
      {{element.firstName}} {{element.lastName}}
    }@else {
      <span class="subtitle-text-color-2">N / A</span>
    }
  }@else if(column == 'contact'){
    @if(element.telecom && element.telecom.length > 0){
      <div class="g-just-flex gap-0 my-12 link-group">
        <div class="g-just-flex gap-5 link-group-words flex-direction-column">
          @for(ct of element.telecom; track $index){
            @if(ct.system=='phone'){
              <div class="top"><a href="tel:+{{ct.value}}">{{ct.value}}</a></div>
            }@else if(ct.system=='email'){
              <div class="bottom subtitle-text-color-2"><a href="mailto:{{ct.value}}">{{ct.value}}</a></div>
            }
          }
        </div>
      </div>
    }@else if(element.email || element.phoneNumber){
      <div class="g-just-flex gap-0 my-12 link-group">
        <div class="g-just-flex gap-5 link-group-words flex-direction-column">
          @if(element.phoneNumber){
            <div class="top"><a href="tel:+{{element.phoneNumber}}">{{element.phoneNumber}}</a></div>
          }
          @if(element.email){
            <div class="bottom subtitle-text-color-2"><a href="mailto:{{element.email}}">{{element.email}}</a></div>
          }
        </div>
      </div>
    }@else {
      <span class="subtitle-text-color-2">N / A</span>
    }
  }@else if(column == 'submitted date'){
    @if(element.submittedAt){
      <div class="g-just-flex gap-0 my-12 link-group">
        <div class="g-just-flex gap-5 link-group-words flex-direction-column">
          <div class="top">{{element.submittedAt | date : "short"}}</div>
          <div class="bottom subtitle-text-color-2">{{element.submittedAt | date : "mediumDate"}}</div>
        </div>
      </div>
    }@else {
      <span class="subtitle-text-color-2">N / A</span>
    }
  }@else if(column == 'account type'){
    @if(element.accountType){
      <span class="subtitle-text-color-2">{{element.accountType}}</span>
    }@else {
      <span class="subtitle-text-color-2">N / A</span>
    }
  }@else if(column == 'gender'){
    @if(element.gender){
      {{element.gender | titlecase}}
    }@else {
      <span class="subtitle-text-color-2">N / A</span>
    }
  }@else if(column == 'date of birth'){
    @if(element.birthDate){
      <div class="g-just-flex gap-0 my-12 link-group">
        <div class="g-just-flex gap-5 link-group-words flex-direction-column">
          <div class="top">{{element.birthDate | date : "shortDate"}}</div>
          <div class="bottom subtitle-text-color-2">{{element.birthDate | age }} Years</div>
        </div>
      </div>
    }@else {
      <span class="subtitle-text-color-2">N / A</span>
    }
  }@else if(column == 'patient type'){
    <span>{{getPatientTypeLabel(element)}}</span>
  }@else if(column == 'address'){
    @if(element.address && element.address.length > 0){
      <div class="g-just-flex gap-0 my-12 link-group">
        <div class="g-just-flex gap-5 link-group-words flex-direction-column">
          <div class="top">{{element.address?.[0]?.line}}</div>
          <div class="bottom subtitle-text-color-2">
            {{element.address?.[0]?.city ? element.address?.[0]?.city + "." : ""}}
            {{element.address?.[0]?.state ? element.address?.[0]?.state + "." : ""}}
            {{element.address?.[0]?.country ? element.address?.[0]?.country + "." : ""}}
            {{element.address?.[0]?.postalCode}}
          </div>
        </div>
      </div>
    }@else {
      <span class="subtitle-text-color-2">N / A</span>
    }
  }@else if(column == 'status'){
    <div style="margin: 0px !important;"
        [attr.class]="'small-chips'+' '+'status-'+statusStyles[element.status.toLowerCase()]['color']+' g-just-flex gap-8'">
      <span>{{element.status}}</span>
      <mat-icon>{{statusStyles[element.status.toLowerCase()]['icon']}}</mat-icon>
    </div>
  }
</td>
                </ng-container>
              }
            }

            <!-- Table Rows -->
            <tr mat-header-row *matHeaderRowDef="tableColumns.concat('action')"></tr>
            <tr mat-row *matRowDef="let row; let dataIndex = dataIndex; columns: tableColumns.concat('action')" (click)="showRow(row)"></tr>
          </table>

          <!-- Paginator -->
          <mat-paginator
            [pageSizeOptions]="[20, 50, 100]"
            [pageSize]="20"
            showFirstLastButtons
            aria-label="Select page of patients">
          </mat-paginator>
        }
      }@else {
        <!-- Loading state when observable hasn't emitted yet -->
        <div style="text-align: center; padding: 40px;">
          <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
        </div>
      }
    </mat-card-content>
  }

</mat-card>
